import React, { useContext, useEffect, useState } from "react";
import { Table, Tag, Space } from "antd";
import _ from "lodash";
import { AppTable } from "../../../_components/AppTable";
import { SearchCriminal } from "../../../_components/searchCriminal";
import { LanguageContext } from "../../../context/LanguageContext";

export const FindFormTable = (props) => {
  console.log("FindFormTable", props);
  const [criminalData, setCriminalData] = useState([]);
  const [criminalHeaders, setCriminalHeaders] = useState([]);
  const { t } = useContext(LanguageContext);
  const requiredKeys = [
    "sr.no",
    "name",
    "cityName",
    "districtName",
    "gunhaCount",
  ];
  const requiredKeysTitle = [
    t("sr.no"),
    t("name"),
    t("unit"),
    t("accused_police_station"),
    t("total_crime"),
  ];

  useEffect(() => {
    if (props.criminalRecords && props.criminalRecords) {
      // setCriminalRecors(props.criminalRecords.basicInfo);
      let columns1 =
        props.criminalRecords &&
        props.criminalRecords &&
        props.criminalRecords.map((itemObj, index) => {
          return {
            ...itemObj,
            key: index + 1,
          };
        });
      console.log("column1", columns1);

      // columns1 && columns1.length && columns1.reverse();

      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
          "Sr.No": props.getSerialNumber(index, props.current, props.pageSize),
        };
      });
      setCriminalData(tempObj);

      let tablelabes = columns1 && columns1.length && Object.keys(columns1[0]);
      console.log("tablelabes", tablelabes);
      tablelabes && tablelabes.unshift("Sr.No");
      console.log("tablelabes1", tablelabes);

      let tableColumns = [];
      tablelabes &&
        tablelabes.length &&
        tablelabes.forEach((item) => {
          if (
            _.filter(requiredKeys, function (o) {
              return o === item;
            }).length
          ) {
            tableColumns.push(item);
          }
        });
      console.log("tableColumns", tableColumns);
      let columnList = tableColumns.map((item, index) => {
        return {
          title: requiredKeysTitle[index],
          dataIndex: item,
          key: item,
        };
      });
      console.log("columnList", columnList);
      setCriminalHeaders(columnList);
    }
  }, [props.criminalRecords]);

  const onEditAccusedForm = (data) => {
    props.onEditAccusedForm(data);
  };
  const onViewAccusedForm = (data) => {
    props.onViewAccusedForm(data);
  };
  const onPreventiveViewAccusedForm = (data) => {
    props.onPreventiveViewAccusedForm(data);
  };
  console.log("criminalData", criminalData);
  console.log("criminalHeaders", criminalHeaders);
  return (
    <>
      {criminalData.length > 0 && (
        <SearchCriminal
          isAccusedFormUpdate={true}
          onEditAccusedForm={onEditAccusedForm}
          onViewAccusedForm={onViewAccusedForm}
          onPreventiveViewAccusedForm={onPreventiveViewAccusedForm}
          data={criminalData}
          columns={criminalHeaders}
          current={props.current}
          pageSize={props.pageSize}
          total={props.total}
          handlePageChange={props.handlePageChange}
          handlePageSizeChange={props.handlePageSizeChange}
          city={props?.city}
          district={props?.district}
          tableLoading={props.tableLoading}
          userid={props?.userid}
          districtName={props.districtName}
          findTextValue={props.findTextValue}
          pc_cities={props.pc_cities}
          searchType={props.searchType}
        ></SearchCriminal>
      )}
    </>
  );
};
